import $ from 'jquery';
import 'slick-carousel';
import AOS from "aos";
import lozad from 'lozad';

$(function () {
	'use strict';

	// Slick sliders

	$('.carousel').on('init', function (event, slick) {
		// console.log("initialized");
		AOS.init();
		const observer = lozad(); // lazy loads elements with default selector as ".lozad"
		observer.observe();

	});
	$('.carousel').slick({
		arrows: false,
		dots: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '100px',
		adaptiveHeight: true,

		responsive: [
			{
				breakpoint: 769,
				settings: {
					centerMode: true,
					centerPadding: '40px',
					slidesToShow: 1
				}
			},
			{
				breakpoint: 540,
				settings: {
					centerMode: false,
					slidesToShow: 1
				}
			}

		]

	});

});

import "../../node_modules/slick-carousel/slick/slick.css";
import "../../node_modules/slick-carousel/slick/slick-theme.css";
